import { render, staticRenderFns } from "./DocumentResearchSource.vue?vue&type=template&id=c5cec1fa&scoped=true&"
import script from "./DocumentResearchSource.vue?vue&type=script&lang=js&"
export * from "./DocumentResearchSource.vue?vue&type=script&lang=js&"
import style0 from "./DocumentResearchSource.vue?vue&type=style&index=0&id=c5cec1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cec1fa",
  null
  
)

export default component.exports